import React from 'react';
import { Stack } from '@mui/material';
import Box, { BoxProps } from '@mui/material/Box';
import { ResourceType } from 'interfaces/ResourceType';
import AmbulanceHeader from './AmbulanceHeader';
import { IRequestAmbulance } from 'interfaces/ResourceRequests';
import { IResponsesDB } from 'interfaces/response.interface';

const ProvidedResourceAmbulance: React.FC<
  {
    name: ResourceType;
    active: boolean;
    ambulance: IRequestAmbulance[];
    responses: IResponsesDB[] | undefined;
  } & BoxProps
> = ({ active = false, name, ambulance, responses }) => {
  return (
    <Stack
      id={`provided-tab-panel-${name}`}
      aria-labelledby={`provided-tab-${name}`}
      hidden={!active}
      role='tab-panel'>
      <Box>
        {active && ambulance && ambulance.length ? (
          ambulance.map((a, idx: number) => {
            //const response = responses?.find((r) => r.id === a.responsesId);
            return (
              <AmbulanceHeader
                key={idx}
                name={name}
                index={idx}
                ambulance={a}
                responses={responses}
              />
            );
          })
        ) : (
          <></>
        )}
      </Box>
    </Stack>
  );
};

export default ProvidedResourceAmbulance;
